import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTableCell, useTableSelectionCheckbox } from 'react-aria';
import Checkbox from 'client/components/aria/Table/Checkbox/Checkbox';

import styles from './TableCheckboxCell.module.scss';

const TableCheckboxCell = ({ cell, state, className, ...props }) => {
    const ref = useRef();
    const { gridCellProps } = useTableCell({ node: cell }, state, ref);
    const { checkboxProps } = useTableSelectionCheckbox(
        { key: cell.parentKey },
        state
    );

    return (
        <td
            className={[
                'govuk-table__cell',
                styles.cell,
                className
            ].join(' ')}
            {...gridCellProps}
            ref={ref}
            data-testid={props['data-testid'] ? props['data-testid'] + '.td' : null}
        >
            <Checkbox
                {...checkboxProps}
                variant='small'
                data-testid={props['data-testid'] ? props['data-testid'] + '.td' : null}
            />
        </td>
    );
};

TableCheckboxCell.propTypes = {
    cell: PropTypes.any,
    state: PropTypes.object,
    className: PropTypes.string,
    'data-testid': PropTypes.string
};

TableCheckboxCell.defaultProps = {};

export default TableCheckboxCell;
